import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  console.error('[Bootstrap Error]', err);

  const errorMessage = err?.message || err?.toString() || '';
  if (errorMessage.toLowerCase().includes('could not find matching config for state')) {
    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, cleanUrl);
    window.location.href = '/';
  }
});
